// Rótulo dos itens da Lista de Verificação Administrativa em tela.
//
// A descrição em português é o dado gravado — o casamento com o que já foi
// salvo é feito por ela (ver `lista-verificacao-administrativa.tsx`), então a
// tradução acontece só na exibição, a partir do código do item. Item fora da
// lista padrão (apreciação antiga, código extra) sai com a descrição do banco.

import { ITENS_VERIFICACAO_PADRAO } from '@/types/lista-verificacao';

/** Assinatura mínima do `t` do `useI18n()` — a constante não importa React. */
type Traduzir = (chave: string) => string;

const CODIGOS_PADRAO = new Set(ITENS_VERIFICACAO_PADRAO.map((i) => i.codigo));

/** `C.4.1` → `apreciacaoTabelas.administrativa.itens.C_4_1` (o ponto separa segmentos). */
export function chaveItemVerificacao(codigo: string): string {
  return `apreciacaoTabelas.administrativa.itens.${codigo.replace(/\./g, '_')}`;
}

export function descricaoItemVerificacao(t: Traduzir, codigo: string, descricao: string): string {
  return CODIGOS_PADRAO.has(codigo) ? t(chaveItemVerificacao(codigo)) : descricao;
}
